import React, { useState, useRef, useEffect } from "react";
import axios from "axios";
import {
  FaPlay,
  FaPause,
  FaVolumeUp,
  FaVolumeDown,
  FaVolumeMute,
  FaBroadcastTower,
  FaList,
  FaSignal,
  FaUsers,
  FaMusic,
  FaUser,
  FaTimes,
} from "react-icons/fa";
import "./RadioPlayer.css";

const RadioPlayer = () => {
  const audioRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [volume, setVolume] = useState(0.7);
  const [muted, setMuted] = useState(false);
  const [bars, setBars] = useState(new Array(16).fill(10));
  const [currentSong, setCurrentSong] = useState("Cargando...");
  const [coverImage, setCoverImage] = useState("https://via.placeholder.com/150");
  const [songHistory, setSongHistory] = useState([]);
  const [listeners, setListeners] = useState(0);
  const [bitrate, setBitrate] = useState(0);
  const [radioStatus, setRadioStatus] = useState("Desconocido");
  const [djName, setDjName] = useState("No DJ");
  const [djProfile, setDjProfile] = useState("https://sonicpanel.globalstream.pro/cp/musiclibrary/nodj.png");
  const [isHistoryVisible, setIsHistoryVisible] = useState(false);
  const [isImageExpanded, setIsImageExpanded] = useState(false); 

  const radioStream = "https://sonicpanel.globalstream.pro//8064/stream";
  const apiURL = "https://sonicpanel.globalstream.pro/cp/get_info.php?p=8064";

  // Obtener datos de la API
  const fetchSongData = async () => {
    try {
      const response = await axios.get(apiURL);
      const { title, history = [], listeners, bitrate, radio_status, art, djusername, djprofile } = response.data;

      setCurrentSong(title);
      setSongHistory(
        history
          .map((song) => song.replace(/^\d+\.\)\s*/, "").replace(/<br>/g, "").trim()) // Elimina numeración "n.)" y <br>
          .slice(0, 10) // Solo muestra las últimas 10 canciones
      );
      setListeners(parseInt(listeners) || 0);
      setBitrate(parseInt(bitrate) || 128);
      setRadioStatus(radio_status === "1" ? "En Línea" : "Fuera de Línea");
      setCoverImage(art || "https://via.placeholder.com/150");
      setDjName(djusername || "No DJ");
      setDjProfile(djprofile || "https://sonicpanel.globalstream.pro/cp/musiclibrary/nodj.png");
    } catch (error) {
      console.error("Error al obtener datos de la API", error);
    }
  };

  useEffect(() => {
    fetchSongData();
    const interval = setInterval(fetchSongData, 5000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    let interval;
    if (isPlaying) {
      interval = setInterval(() => {
        setBars(bars.map(() => Math.floor(Math.random() * 50) + 10)); // Simulación de barras
      }, 150);
    } else {
      setBars(new Array(16).fill(10));
    }
    return () => clearInterval(interval);
  }, [isPlaying]);

  const togglePlay = () => {
    if (isPlaying) {
      audioRef.current.pause();
    } else {
      audioRef.current.play();
    }
    setIsPlaying(!isPlaying);
  };

  const toggleMute = () => {
    setMuted(!muted);
    audioRef.current.muted = !audioRef.current.muted;
  };

  const handleVolumeChange = (e) => {
    const newVolume = e.target.value;
    setVolume(newVolume);
    audioRef.current.volume = newVolume;
  };

  const toggleImageSize = () => {
    setIsImageExpanded(!isImageExpanded);
  };

  return (
    <div className="radio-wrapper">
      <div className="radio-container">
        <audio ref={audioRef} src={radioStream} />



        {/* Visualización del Ritmo */}
        <div className="visualizer">
          {bars.map((height, index) => (
            <div key={index} className="bar" style={{ height: `${height}px` }}></div>
          ))}
        </div>

        <div className="current-song">
          <img
            src={coverImage}
            alt="Cover"
            className={`cover-image ${isImageExpanded ? "expanded" : ""}`}
            onClick={toggleImageSize} 
          />
          <div><strong>🎵</strong> {currentSong}</div>
        </div>

        {/* Información del DJ 
        <div className="dj-info">
          <img src={djProfile} alt="DJ" className="dj-profile" />
          <p><FaUser /> <strong>DJ:</strong> {djName}</p>
        </div> */}

        <div className="controls">
          <button onClick={togglePlay} className={`play-button ${isPlaying ? "active" : ""}`}>
            {isPlaying ? <FaPause /> : <FaPlay />}
          </button>

          <button onClick={toggleMute} className={`mute-button ${muted ? "active" : ""}`}>
            {muted ? <FaVolumeMute /> : <FaVolumeUp />}
          </button>

          <div className="volume-control">
            <FaVolumeDown />
            <input type="range" min="0" max="1" step="0.01" value={muted ? 0 : volume} onChange={handleVolumeChange} disabled={muted} />
            <FaVolumeUp />
          </div>

          <button className="history-button" onClick={() => setIsHistoryVisible(!isHistoryVisible)}>
            {isHistoryVisible ? <FaTimes /> : <FaList />} Historial
          </button>
        </div>

        <div className="radio-status">
        <p><FaUsers /> <strong>Oyentes:</strong> {listeners}</p>
        <p><FaMusic /> <strong>Bitrate:</strong> {bitrate} kbps</p>
        </div>

      </div>

      {/* Historial de canciones en un panel lateral */}
      <div className={`history-panel ${isHistoryVisible ? "visible" : ""}`}>
        <h3>🎼 Historial de Canciones</h3>
        <ul>
          {songHistory.map((song, index) => (
            <li key={index}>{song}</li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default RadioPlayer;
